export const OktaClientId = '0oa15aymctiioGwei697'
export const ENV = 'hurstnorth' as string
export const OVERSIGHT_ENV_NAME = 'oversight'
export const GCS_ENV_NAME = 'hurstnorth'
export const SUBDOMAIN_SUFFIX = 'gcs'
